import {
  AssociationMember,
  associationMemberSchema,
} from "@boark/shared/types/association-member";
import { AssociationUserCreate } from "@boark/shared/types/association-user-create";
import { AssociationUserUpdate } from "@boark/shared/types/association-user-update";

import { postRequest, putRequest } from "../utils/request";

const API_BASE_URL = process.env.API_BASE_URL || "/api";

export async function createAssociationUser(
  input: AssociationUserCreate,
): Promise<AssociationMember> {
  return postRequest(
    `${API_BASE_URL}/association/members`,
    input,
    associationMemberSchema,
  );
}

export async function updateAssociationUser(
  id: string,
  input: AssociationUserUpdate,
): Promise<AssociationMember> {
  return putRequest(
    `${API_BASE_URL}/association/members/${id}`,
    input,
    associationMemberSchema,
  );
}
